import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { Seo } from "@/lib/seo";
import { PageHero } from "@/components/page-hero";
import { Reveal } from "@/lib/motion";
import { GUIAS } from "@/content/guides";

export default function Guias() {
  return (
    <>
      <Seo
        title="Guías"
        description="Guías editoriales de Tulevik Legal: qué revisar antes de firmar una renta, cómo prepararte para una consulta de separación, qué documentos conservar y más."
        path="/guias"
      />
      <PageHero
        eyebrow="Biblioteca editorial"
        titulo="Guías para leer antes de decidir"
        lead="Publicamos pocas piezas, pero útiles: las que casi cualquiera necesita en algún momento. Escritas en lenguaje claro, revisadas y actualizables."
      />
      <section className="bg-parchment">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
          <div>
            {GUIAS.map((g, i) => (
              <Reveal key={g.slug} delay={Math.min(i * 0.04, 0.2)} y={16}>
                <Link
                  to={`/guias/${g.slug}`}
                  data-testid={`guias-link-${g.slug}`}
                  className="group flex items-start justify-between gap-6 border-t border-hairline py-8 transition-colors last:border-b hover:bg-parchment-surface/70 sm:px-4"
                >
                  <div className="max-w-2xl">
                    <p className="font-mono text-[11px] tracking-[0.22em] text-azul">
                      GUÍA {String(i + 1).padStart(2, "0")}
                    </p>
                    <h2 className="mt-3 font-serif text-2xl text-ink-deep transition-transform duration-300 group-hover:translate-x-1 sm:text-3xl">
                      {g.titulo}
                    </h2>
                    <p className="mt-2.5 text-sm leading-relaxed text-ink-muted sm:text-base">{g.resumen}</p>
                    <p className="mt-4 inline-flex items-center gap-1.5 font-mono text-xs text-ink-muted">
                      <Clock className="h-3.5 w-3.5" />
                      {g.lecturaMin} min de lectura
                    </p>
                  </div>
                  <ArrowRight className="mt-2 h-5 w-5 shrink-0 text-ink-muted transition-all duration-300 group-hover:translate-x-1 group-hover:text-azul" />
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
